module.exports = __webpack_public_path__ + "teqbahn-assets/media/impact2.31c2268e.jpeg";